let prefixer: string | undefined;

const hostname: string = window.location.hostname;
const port: string = window.location.port;

if (process.env.REACT_APP_API_URL) {
  prefixer = process.env.REACT_APP_API_URL;
} else {
  switch (hostname) {
    case process.env.REACT_APP_STAGING_HOST:
      prefixer = process.env.REACT_APP_STAGING_API_URL;
      break;
    case process.env.REACT_APP_PREPROD_HOST:
      prefixer = process.env.REACT_APP_PREPROD_API_URL;
      break;
    case process.env.REACT_APP_DEV_HOST:
      prefixer = process.env.REACT_APP_DEV_API_URL;
      break;
    case process.env.REACT_APP_PROD_HOST:
      prefixer = process.env.REACT_APP_PROD_API_URL;
      break;
    default:
      if (port === '3000') {
        prefixer = process.env.REACT_APP_LOCAL_API_URL;
      } else {
        prefixer = process.env.REACT_APP_DEV_API_URL;
      }
  }
}

const authUrl = `${prefixer}/auth/`;
const userUrl = `${prefixer}/user/`;
const userMeUrl = `${userUrl}me/`;
const calculatriceCEEUrl = `${prefixer}/calculatriceCEE/`;
const soumissionDossierUrl = `${prefixer}/soumissionDossier/`;
const generationDocumentUrl = `${prefixer}/generation-document/`;
const categoriesRevenusUrl = `${prefixer}/categoriesRevenus/`;
const calculatriceMPRUrl = `${prefixer}/calculatriceMPR/`;
const simulationsUrl = `${prefixer}/simulations/`;
const siretUrl = `${prefixer}/siret/`;
const supportUrl = `${prefixer}/support/`;
const leadsUrl = `${prefixer}/leads`;

export const AuthUrls: Record<string, string> = {
  PASSWORD_LOGIN: `${authUrl}login`,
  RESET_PASSWORD_INIT: `${authUrl}forgot-password`,
  RESET_PASSWORD: `${authUrl}reset-password`,
  CREATE_PASSWORD: `${authUrl}create-password`,
  REFRESH_TOKEN: `${authUrl}refresh-token`,
  IMPERSONATE: `${authUrl}impersonate`,
  CREATE_PASSWORD_TOKEN_STATUS: `${prefixer}/auth/activation-token/status`,
};

export const UserUrls: Record<string, string> = {
  GET_CONNECTED_INFO: `${userMeUrl}`,
  GET_ACCOUNT_INFO: `${userUrl}infos`,
  GET_ACCOUNT_SF_OWNER_INFO: `${userMeUrl}sf-owner`,
  GET_ACCOUNT_SF_NOTIFICATIONS: `${userMeUrl}sf-notifications`,
  RESEND_FIRST_EMAIL: `${prefixer}/user/resend-first-email`,
};

export const PickListUrls = {
  GET: (objectType: string, fieldName: string) =>
    `${prefixer}/${objectType}/picklist/${fieldName}`,
};

export const DossiersUrls = {
  ADD: `${prefixer}/dossiers`,
  EXPORT: `${prefixer}/dossiers/export`,
  LIST: `${prefixer}/dossiers`,
  GET_REFERENTS_COMMERCIAUX: `${prefixer}/dossiers/referents-commerciaux`,
  GET_FILIALES: `${prefixer}/dossiers/filiales`,
  GET_PROFESSIONNELS: `${prefixer}/dossiers/professionnels`,
  GET_STATUS_DASHBOARD: `${prefixer}/dossiers/status-dashboard`,
  GET_PAIEMENTS_DASHBOARD: `${prefixer}/dossiers/paiements-dashboard`,
  GET: (dossierId: string, operationId: string) =>
    `${prefixer}/dossiers/${dossierId}/${operationId}`,
  PUT: (dossierId: string) => `${prefixer}/dossiers/${dossierId}`,
  OPERATIONS: (dossierId: string, offset: number = 0, limit: number = 10) =>
    `${prefixer}/dossiers/${dossierId}/operations?offset=${offset}&limit=${limit}`,
  OPERATION: (dossierId: string, operationId: string) =>
    `${prefixer}/dossiers/${dossierId}/operations/${operationId}`,
  OPERATION_ATTACHMENTS: (dossierId: string, operationId: string) =>
    `${prefixer}/dossiers/${dossierId}/operations/${operationId}/attachments`,
  LITIGE_NON_CONFORMITE_ADMIN: (dossierId: string, litigeId: string) =>
    `${prefixer}/dossiers/${dossierId}/litiges/${litigeId}/non-conformites-admin`,
  AUDIT_CONTENTIEUX_ATTACHMENTS: (
    dossierId: string,
    auditContentieuxId: string,
  ) =>
    `${prefixer}/dossiers/${dossierId}/audit-contentieux/${auditContentieuxId}/attachments`,
};

export const AttachmentsUrls = {
  DOWNLOAD_ATTACHMENT: (token: string) =>
    `${prefixer}/attachments/download/${token}`,
  GET_DOWNLOAD: (attachmentId: string) =>
    `${prefixer}/attachments/get-download/${attachmentId}`,
  DELETE: (attachmentId: string) => `${prefixer}/attachments/${attachmentId}`,
  DOWNLOAD_ATTESTATION_LEVEE_NON_CONFORMITES: () =>
    `${prefixer}/attachments/attestation/download`,
};

export const CalculatriceCEEUrls: Record<string, string> = {
  LISTE_FOST: `${calculatriceCEEUrl}listeFost`,
  FOST_INFORMATION: `${calculatriceCEEUrl}fostInformation`,
  CHAMPS_REQUIS: `${calculatriceCEEUrl}champsRequis`,
  VOLUME_ET_PRIME_CEE: `${calculatriceCEEUrl}volumeEtPrimeCEE`,
  VOLUME_ET_PRIME_CEE_PREVIEW: `${calculatriceCEEUrl}volumeEtPrimeCEE/preview`,
  SIMULATIONS_UPDATE: `${calculatriceCEEUrl}simulations/update`,
  CDP_ASSOCIE: `${calculatriceCEEUrl}cdpAssocie`,
};

export const SoumissionDossierUrls: Record<string, string> = {
  ADRESSES: `${soumissionDossierUrl}adresses`,
  BENEFICIAIRES: `${soumissionDossierUrl}beneficiaires`,
  SIRETS: `${soumissionDossierUrl}sirets`,
  INTERLOCUTEURS: `${soumissionDossierUrl}interlocuteurs`,
  SITE_INTERLOCUTEURS: `${soumissionDossierUrl}interlocuteurs-sites`,
  POST: `${soumissionDossierUrl}insert`,
};
export const SupportUrls = {
  CREATE: `${supportUrl}`,
  LIST: `${supportUrl}`,
  DETAIL: (id: string) => `${supportUrl}${id}`,
  ADD_FEEDITEM: (id: string) => `${supportUrl}${id}/feeditems`,
  DOWNLOAD_FILE: (fileId: string) => `${supportUrl}files/${fileId}`,
};

export const LeadsUrls = {
  LIST: leadsUrl,
  SUIVI: `${leadsUrl}/suivi`,
  SUIVI_DETAIL: (id: string) => `${leadsUrl}/suivi/${id}`,
  SUIVI_COUNTS: `${leadsUrl}/suivi/counts`,
  SUIVI_ADVANCE: (opportunityId: string) =>
    `${leadsUrl}/suivi/${opportunityId}/advance`,
  SUIVI_ABANDON: (opportunityId: string) =>
    `${leadsUrl}/suivi/${opportunityId}/abandon`,
  SUIVI_PAUSE: (opportunityId: string) =>
    `${leadsUrl}/suivi/${opportunityId}/pause`,
  SUIVI_REACTIVATE: (opportunityId: string) =>
    `${leadsUrl}/suivi/${opportunityId}/reactivate`,
  SUIVI_EDIT_TASK: (opportunityId: string, taskId: string) =>
    `${leadsUrl}/suivi/${opportunityId}/task/${taskId}`,
  SUIVI_PICKLIST_TYPES_TRAVAUX: `${leadsUrl}/suivi/picklist/types-travaux`,
  SUIVI_PICKLIST_MOTIFS_ABANDON: `${leadsUrl}/suivi/picklist/motifs-abandon`,
  SUIVI_PICKLIST_MOTIFS_PAUSE: `${leadsUrl}/suivi/picklist/motifs-pause`,
  ACCEPT: (id: string) => `${leadsUrl}/${id}/accept`,
  REFUSE: (id: string) => `${leadsUrl}/${id}/refuse`,
};

export const GenerationDocumentUrls: Record<string, string> = {
  ATTESTATION_HONNEUR: `${generationDocumentUrl}generate-attestation-honneur`,
  CADRE_CONTRIBUTION: `${generationDocumentUrl}generate-cadre-contribution`,
  LIST_FOST: `${generationDocumentUrl}liste-fost`,
};

export const ExternalUrls = {
  GET_NEWS_RSS: 'https://www.hellio.com/actualites/rss.xml',
};

export const LOCATION_URL = {
  SEARCH: (searchValue: string) =>
    `https://data.geopf.fr/geocodage/search/?q=${searchValue}&postcode=${searchValue}&limit=1`,
};

export const CategoriesRevenus: Record<string, string> = {
  PALIERS_MPR: `${categoriesRevenusUrl}paliersMPR`,
};

export const CalculatriceMPRUrls: Record<string, string> = {
  CHAMPS_REQUIS: `${calculatriceMPRUrl}champsRequis`,
  PRIME: `${calculatriceMPRUrl}prime`,
  PRIME_PREVIEW: `${calculatriceMPRUrl}prime/preview`,
};

export const SimulationsUrls = {
  LIST: `${simulationsUrl}`,
  EXPORT: `${simulationsUrl}export`,
  VIEW(id: string) {
    return `${simulationsUrl}${id}`;
  },
  UPDATE: `${simulationsUrl}update`,
  SAVE_BATCH: `${simulationsUrl}save-batch`,
  DELETE(id: string) {
    return `${simulationsUrl}${id}`;
  },
};

export const SiretUrls = {
  SIRET_ACCOUNT_CREATION: (siretNumber: string) =>
    `${siretUrl}${siretNumber}/create-account`,
};
